import React from 'react';

const Icon = ({ size = '51', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 51 51" fill="none" {...other}>
            <path
                d="M44.078 25.334c0 10.355-8.395 18.75-18.75 18.75m18.75-18.75c0-10.355-8.395-18.75-18.75-18.75m18.75 18.75h-11.25m-7.5 18.75c-10.355 0-18.75-8.395-18.75-18.75m18.75 18.75c4.142 0 7.5-8.395 7.5-18.75m-7.5 18.75c-4.142 0-7.5-8.395-7.5-18.75m-11.25 0c0-10.355 8.395-18.75 18.75-18.75m-18.75 18.75h11.25m7.5-18.75c-4.142 0-7.5 8.395-7.5 18.75m7.5-18.75c4.142 0 7.5 8.395 7.5 18.75m0 0h-15"
                stroke="black"
                strokeWidth="1.88"
            />
        </svg>
    );
};
export default React.memo(Icon);
